import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation DeleteProjectMutation($input: DeleteProjectInput!) {
        deleteProject(input: $input) {
            deletedProjectId
        }
    }
`;

export function commit(environment, args) {
    const { projectId, onCompleted, onError } = args;

    return commitMutation(environment, {
        mutation,
        variables: {
            input: {
                projectId,
            },
        },
        onCompleted,
        onError,
    });
}
